import { MutationTree } from 'vuex';
import { Technician } from './../../../models/Technician';
import technicianUtils from '../../../utils/technician';
import { technicianUtils as generalTechnicianUtils } from "@puls/puls-general-utils";

export const TechnicianMutations = {
	UPDATE_DETAILS: "UPDATE_DETAILS",
	SET_SKILLS_MAP: "SET_SKILLS_MAP",
	UPDATE_SELECTED_SKILL: "UPDATE_SELECTED_SKILL",
	UPDATE_All_SKILLS: "UPDATE_ALL_SKILL",
	CLEAR_All_SKILLS: "CLEAR_All_SKILLS",
	SET_SERVICE_AREAS: "SET_SERVICE_AREAS",
	UPDATE_SELECTED_AREA: "UPDATE_SELECTED_AREA",
	SET_SELECTED_AREAS: "SET_SELECTED_AREAS",
	UPDATE_ALL_AREAS: "UPDATE_ALL_AREAS",
	CLEAR_ALL_AREAS: "CLEAR_ALL_AREAS",
	SET_MARKET_ID: "SET_MARKET_ID",
	CLEAR_MARKET_ID: "CLEAR_MARKET_ID",
	UPDATE_FIELD: "UPDATE_FIELD",
	UPDATE_EMAIL: "UPDATE_EMAIL",
	UPDATE_ZIPCODE: 'UPDATE_ZIPCODE',
	SET_ADDRESS_COORDINATES: "SET_ADDRESS_COORDINATES"
}

export const mutations: MutationTree<any> = {
	[TechnicianMutations.UPDATE_DETAILS] (state: Technician, payload: any) {
		state.notification_preference = payload.notification_preference;
		state.service_provider_id = payload.service_provider_id;
		state.status_id = payload.status.id;
		state.market_id = payload.market.id;
		state.first_name = payload.first_name;
		state.last_name = payload.last_name;
		state.service_provider_id = payload.service_provider_id;
		state.image = payload.image_url;
		state.address = payload.full_address;
		state.skills = payload.skills;
		state.email = payload.email;
		state.phone = payload.phone;		
		state.service_areas = new Set(payload.areas);
		state.radius = payload.radius;
		state.address_coordinates = {
			lat: payload.preferred_location?.latitude || 0,
			lng: payload.preferred_location?.longitude || 0
		}

		state.company_id = payload.company_id;
		state.company_owner_technician_id = payload.company_owner_technician_id;
		state.is_company = payload.is_company;
		state.is_company_owner = payload.is_company_owner;

		if (generalTechnicianUtils.isLeadPartner(payload.service_provider_id)) { 
			state.total_leads = payload.total_leads;
			state.lead_package_auto_renew = payload.lead_package_auto_renew;
			state.current_plan_leads = payload.current_plan_leads;
			state.lead_start_date = payload.lead_start_date;
			state.remaining_leads_count = payload.remaining_leads_count;
		}
	},
	[TechnicianMutations.UPDATE_FIELD] (state: Technician, payload: { key: string, value: any }) {
		(state as any)[payload.key] = payload.value;
	},
	[TechnicianMutations.UPDATE_SELECTED_SKILL] (state: Technician, payload: { id: number }) {
		const { id } = payload;
		if (state.skills.has(id)) {
			state.skills.delete(id)
		} else {
			state.skills.add(id);
		}
	},
	[TechnicianMutations.UPDATE_All_SKILLS] (state: Technician, payload: { id: number }) {
		const { id } = payload;
		const hasSkillSelected = technicianUtils.devicesByCategories[id].devices.some((deviceId: number) => state.skills.has(deviceId));
		technicianUtils.devicesByCategories[id].devices.forEach((deviceId: number) => {
			hasSkillSelected ? state.skills.delete(deviceId) : state.skills.add(deviceId);
		})
	},
	[TechnicianMutations.CLEAR_All_SKILLS] (state: Technician, payload: { id: number }) {
		const { id } = payload;
		technicianUtils.devicesByCategories[id].devices.forEach((deviceId: number) => {
			state.skills.delete(deviceId);
		})
	},
	[TechnicianMutations.UPDATE_ALL_AREAS] (state: Technician, payload: Array<{ id: number }>) {
		const isSelected = payload.some((area) => state.service_areas.has(area.id));
		payload.forEach((area) => {
			if (isSelected) {
				state.service_areas.delete(area.id);
			} else {
				state.service_areas.add(area.id);
			}
		})
	},
	[TechnicianMutations.CLEAR_ALL_AREAS] (state: Technician) {
		state.service_areas.clear();
	},
	[TechnicianMutations.UPDATE_SELECTED_AREA] (state: Technician, payload: { id: number }) {
		const { id } = payload;
		state.service_areas.has(id) ? state.service_areas.delete(id) : state.service_areas.add(id);
	},
	[TechnicianMutations.SET_SELECTED_AREAS] (state: Technician, payload: Array<{ id: number }>) {
		payload.forEach((area) => {
			state.service_areas.add(area.id);
		})
	},
	[TechnicianMutations.CLEAR_MARKET_ID] (state: Technician) {
		state.market_id = 0;
	},
	[TechnicianMutations.SET_ADDRESS_COORDINATES] (state: Technician, payload: { lat: number, lng: number }) {
		state.address_coordinates = payload;
	}
}
